/* eslint-disable jsx-a11y/anchor-has-content */

/* eslint-disable jsx-a11y/anchor-is-valid */
import { Table } from 'antd';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { t_equipment_lease } from '../../types';

type Props = {
  data: t_equipment_lease[];
};

const TableMachine = ({ data }: Props) => {
  const history = useHistory();
  return (
    <div>
      <Table
        rowKey="lease_id"
        onRow={(record) => {
          return {
            onClick: () => {
              history.push('/machine/detail', { itemId: record.i_id });
            },
          };
        }}
        columns={columns}
        dataSource={data}
        pagination={false}
      />
    </div>
  );
};

const columns: any = [
  {
    title: 'リース期間',
    dataIndex: 'lease_start_date',
    key: 'lease_start_date',
    align: 'center',
    render(text: string, row: any) {
      return {
        props: {
          style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left', padding: '8px' },
          className: 'standardFont',
        },
        children: (
          <div>
            {text && moment(text).format('YYYY年MM月DD日')}
            {row?.lease_end_date && `〜${moment(row.lease_end_date).format('YYYY年MM月DD日')}`}
          </div>
        ),
      };
    },
  },
  {
    title: '契約日',
    dataIndex: 'lease_contract_date',
    key: 'lease_contract_date',
    align: 'center',
    render(text: string) {
      return {
        props: {
          style: { padding: '8px' },
          className: 'standardFont',
        },
        children: <div>{moment(text).format('YYYY年MM月DD日')}</div>,
      };
    },
  },
  {
    title: 'リース会社',
    dataIndex: 'lease_company',
    key: 'lease_company',
    align: 'center',
    render(text: string) {
      return {
        props: {
          style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left', padding: '8px' },
          className: 'standardFont',
        },
        children: <div>{text}</div>,
      };
    },
  },
  {
    title: '契約番号',
    dataIndex: 'lease_contract_id',
    key: 'lease_contract_id',
    align: 'center',
    render(text: string) {
      return {
        props: {
          style: { textAlign: 'left', padding: '8px' },
          className: 'standardFont',
        },
        children: <div>{text}</div>,
      };
    },
  },
  {
    title: '台数',
    dataIndex: 'machine_quantity',
    key: 'machine_quantity',
    align: 'center',
    render(text: string, row: any) {
      return {
        props: {
          style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left', padding: '8px' },
          className: 'standardFont',
        },
        children: (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            {/* wait spec hover display button 契約終了 */}
            {text}台{' '}
            {row?.Status === 'End of a contract' || row?.Status === '契約終了' ? (
              <span style={{ backgroundColor: '#c4c4c4', color: 'black', padding: '6px 6px', marginLeft: '24px' }}>
                契約終了
              </span>
            ) : (
              ''
            )}
          </div>
        ),
      };
    },
  },
];

export default TableMachine;
